import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class O2PortalGlobalAsuAwardsService {

    constructor(protected httpClient: HttpClient) { }
    baseUrl = environment.apiBaseUrl;
    getO2PortalGlobalASUAwards() {
      return this.httpClient.get<any[]>(this.baseUrl + 'O2PortalGlobalASUAwards');
  }
}
